import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";

import FileUploader from "@components/FileUploader";
import GroupService from "@services/Group";
import { generateUniqueFileName } from "@utils/file";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  dialogContent: {
    width: "520px",
    maxWidth: "100%",
    overflow: "visible",
    boxSizing: "border-box",
  },
  fileExample: {
    display: "table",
    marginTop: "10px",
  },
}));

function GroupNumbersImporter(props) {
  const classes = useStyles();

  const accountId = useSelector((state) => state.account.id);

  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  function createUniqueFileName(file) {
    const uniqueFileName = generateUniqueFileName(file);
    const uploadFileName = `${accountId}/${props.listId}/${uniqueFileName}`;
    return uploadFileName;
  }

  function importFile() {
    if (file) {
      setLoading(true);

      const fileName = createUniqueFileName(file);
      GroupService.import(file, fileName)
        .then(() => {
          toast.success(
            "Arquivo importado. O processamento é assincrono e pode demorar alguns segundos para que as alterações sejam aplicadas."
          );
          handleSuccess();
          setLoading(false);
        })
        .catch((e) => {
          console.error(e);
          toast.error("Erro ao importar arquivo!");
          setLoading(false);
        });
    } else {
      toast.warning("Nenhum arquivo selecionado!");
    }
  }

  function clearForm() {
    setFile(null);
    setLoading(false);
  }

  function handleClickClose() {
    if (!loading) {
      props.onCancel();
      clearForm();
    }
  }

  function handleClickCancel() {
    if (!loading) {
      props.onCancel();
      clearForm();
    }
  }

  function handleClickImport() {
    if (!loading) {
      importFile();
    }
  }

  function handleChangeFile(file) {
    setFile(file);
  }

  function handleSuccess() {
    clearForm();
    props.onSuccess();
  }

  return (
    <Dialog
      open={props.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClickClose}
    >
      <DialogTitle>Carregar arquivo de números de telefone</DialogTitle>

      <DialogContent className={classes.dialogContent}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FileUploader
              file={file}
              onChange={handleChangeFile}
              accept={[".txt"]}
            />
            <Link
              href="/files/examples/group_numbers.txt"
              target="_blank"
              className={classes.fileExample}
            >
              <Typography>Exemplo de arquivo</Typography>
            </Link>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button disabled={loading} onClick={handleClickCancel}>
          Cancelar
        </Button>
        <Button
          disabled={loading || !file}
          onClick={handleClickImport}
          color="primary"
        >
          Importar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

GroupNumbersImporter.propTypes = {
  open: PropTypes.bool.isRequired,
  listId: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
};

GroupNumbersImporter.defaultProps = {
  open: false,
  listId: "",
  onCancel: () => {},
  onSuccess: () => {},
};

export default GroupNumbersImporter;
